import React from "react";
import { useBusinessContext } from "../../../../../context/business";

const Staff = ({ data: member }) => {
  const { first_name, last_name, profile_picture, role } = member;
  const { setSelectedBusiness } = useBusinessContext();

  const selectStaff = () => {
    setSelectedBusiness({ type: "SELECT_STAFF", data: member });
  };

  return (
    <button onClick={selectStaff} className="card selectStaff flex">
      {profile_picture ? (
        <img
          src={profile_picture}
          alt=""
          srcset=""
          className="profile_picture"
        />
      ) : (
        <p className="initials">
          {first_name?.[0]}
          {last_name?.[0]}
        </p>
      )}

      <div className="flex arrow_container">
        <div className="text_holder">
          <p className="name">
            {first_name} {last_name}
          </p>
          {!!role && <p className="faint">{role}</p>}
        </div>
      </div>
    </button>
  );
};

export default Staff;
